<script lang="ts">
  import theTime from "$lib/utils/the-time";
  let {
    chartWidth,
    hoveredHour = $bindable(),
    selectedHour = $bindable(),
    hours,
  }: {
    chartWidth: number;
    hoveredHour?: number;
    selectedHour?: number;
    hours: string[];
  } = $props();

  let chartInteraction: HTMLDivElement;
  let hovering = $state(false);
  let touching = $state(false);

  const fromPointer = ([x]: [number], opt: { set?: boolean; toggleable?: boolean } = {}) => {
    let arrayIndex = Math.floor((x / chartWidth) * hours.length);
    let itemIndex = arrayIndex;

    if (itemIndex < 0) itemIndex = 0;
    if (itemIndex > +theTime(hours[hours.length - 1]).to("HH")) itemIndex = hours.length - 1;

    if (!touching && hovering) hoveredHour = itemIndex;
    const newSelectedHour = itemIndex;

    if (opt?.set) {
      selectedHour =
        opt?.toggleable && selectedHour === newSelectedHour ? undefined : newSelectedHour;
    } else if (opt?.toggleable) {
      selectedHour = opt?.toggleable && selectedHour === newSelectedHour ? undefined : selectedHour;
    }
  };

  $effect(() => {
    if (
      (!hovering && typeof hoveredHour === "number") ||
      (touching && typeof hoveredHour === "number")
    )
      hoveredHour = undefined;
  });
</script>

<div
  aria-hidden="true"
  class="chart-interaction unset hover:touch-none"
  class:hoverable={!!hoveredHour}
  bind:this={chartInteraction}
  ontouchmove={(e) => {
    if (!touching) touching = true;
    if (hovering) hovering = false;
    if (!e.touches?.length) return;
    const x = e.touches[0].clientX - chartInteraction.getBoundingClientRect().left;
    fromPointer([x], { set: true });
  }}
  ontouchstart={(e) => {
    if (!touching) touching = true;
    if (hovering) hovering = false;
    if (!e.touches?.length) return;
    const x = e.touches[0].clientX - chartInteraction.getBoundingClientRect().left;
    fromPointer([x], { set: true, toggleable: true });
  }}
  onclick={(e) => {
    if (touching) return;
    fromPointer([e.clientX - chartInteraction.getBoundingClientRect().left], {
      set: true,
      toggleable: true,
    });
  }}
  onmousemove={(e) => {
    if (touching) return;
    if (!hovering) hovering = true;
    fromPointer([e.clientX - chartInteraction.getBoundingClientRect().left]);
  }}
  onmouseleave={() => {
    if (hovering) hovering = false;
    if (touching) touching = false;
  }}
></div>

<style lang="postcss">
  .chart-interaction {
    position: absolute;
    inset: -9px 0 -1.1em;
    z-index: 9;
    cursor: pointer;
  }
</style>
